var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"auth-form"},[_c('div',{staticClass:"small-tf-logo"},[_vm._v("\n    WatchTower Technologies\n  ")]),_c('h2',[_vm._t("title")],2),_c('p',[_vm._t("description")],2),_c('a',{attrs:{"href":"mailto:support@watchtowerbenefits.com"},domProps:{"textContent":_vm._s('support@watchtowerbenefits.com')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }